// Button.jsx
import React from 'react'
import { Loading2 } from './loading'
import { useAuth } from '../context/AuthContext'
import { checkPermission, PermissionAction } from './permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { FaRegEye, FaRegPenToSquare, FaRegTrashCan } from 'react-icons/fa6'
import { Tooltip } from './Tooltip'

const Button = ({
  type,
  onClick,
  disabled,
  title,
  className,
  btnStyle,
  rightIcon,
  loading
}: {
  loading?: boolean
  rightIcon?: any
  type?: any
  disabled?: boolean
  onClick?: any
  title?: any
  className?: any
  btnStyle?: 'btn-outline' | 'btn-primary' | 'btn-blue' | string
}) => {
  const { t } = useTranslation()
  return (
    <button
      disabled={disabled || loading}
      type={type || 'button'}
      onClick={onClick}
      className={`align-items-center align-center flex justify-center rounded-md px-4 py-2 ${className} hover:opacity: 12 ${btnStyle === 'btn-outline' ? 'border border-slate-500 text-slate-500' : ''} ${(disabled || loading) && 'opacity-50'} ${btnStyle === 'btn-blue' && `bg-[#2196F3] text-white`} ${
        btnStyle === 'btn-primary' && `'btn-primary bg- bg-primary text-white`
      } `}
    >
      {title ? t(title) : ''}{' '}
      {rightIcon && <div className='ml-2'>{rightIcon}</div>}
      {loading && (
        <span className='ml-2'>
          <Loading2 />
        </span>
      )}
    </button>
  )
}

export default Button
export type Button2Props = {
  type?: 'button' | 'submit' | 'reset' | any
  onClick?: (data?: any) => void
  disabled?: boolean
  title?: string
  titleSlot?: Record<string, any>
  className?: string
  btnStyle?: 'outline' | 'primary' | string
  rightIcon?: any
  leftIcon?: any
  loading?: boolean
  model?: string
  action?: PermissionAction
}
export const Button2 = ({
  type = 'button',
  onClick,
  disabled,
  title,
  titleSlot = {},
  className,
  btnStyle = 'primary',
  rightIcon,
  leftIcon,
  loading,
  model,
  action
}: Button2Props) => {
  const { t } = useTranslation()
  const { currentUser } = useAuth()
  if (model && action && !checkPermission(currentUser, model, action))
    return null
  return (
    <button
      disabled={disabled || loading}
      type={type}
      onClick={onClick}
      className={`mt-1.5 inline-flex w-full justify-center rounded-md bg-${btnStyle} px-4 py-2 text-sm font-semibold shadow-sm hover:opacity-75 disabled:opacity-75 sm:mt-0 sm:w-auto text-${
        btnStyle === 'outline' ? 'primary border border-primary'
        : btnStyle === 'secondary' ? 'primary'
        : 'white'
      } ${className || ''}`}
    >
      {leftIcon && <div className='mr-1'>{leftIcon}</div>}
      {title ? t(title, titleSlot) : ''}
      {rightIcon && <div className='ml-2'>{rightIcon}</div>}
      {action === 'create' && (
        <div className='ml-2'>
          <FontAwesomeIcon icon={faPlus} />
        </div>
      )}
      {loading && (
        <span
          className={`ml-2 ${btnStyle === 'outline' ? ' text-primary' : ''}`}
        >
          <Loading2 />
        </span>
      )}
    </button>
  )
}
type IconButtonProps = {
  onClick?: (data?: any) => void
  className?: string
  icon?: any
  model?: string
  action?: PermissionAction
  title?: string
}
export const IconButton = ({
  onClick,
  className,
  icon,
  model,
  action,
  title
}: IconButtonProps) => {
  const { t } = useTranslation()
  const { currentUser } = useAuth()
  if (model && action && !checkPermission(currentUser, model, action))
    return null
  return (
    action === 'read' ?
      <Tooltip title={t(title || 'Preview')}>
        <FaRegEye
          onClick={onClick}
          className={
            className || 'mx-1 cursor-pointer hover:opacity-75 fa-lg inline'
          }
        />
      </Tooltip>
    : action === 'update' ?
      <Tooltip title={t(title || 'Edit')}>
        <FaRegPenToSquare
          onClick={onClick}
          className={
            className || 'mx-1 cursor-pointer hover:opacity-75 fa-lg inline'
          }
        />
      </Tooltip>
    : action === 'delete' ?
      <Tooltip title={t(title || 'Delete')}>
        <FaRegTrashCan
          onClick={onClick}
          className={
            className ||
            'mx-1 cursor-pointer hover:opacity-75 fa-lg text-red-500 inline'
          }
        />
      </Tooltip>
    : <Tooltip title={t(title || '')}>
        <FontAwesomeIcon
          onClick={onClick}
          className={
            className || 'mx-1 cursor-pointer hover:opacity-75 fa-lg inline'
          }
          icon={icon || ''}
        />
      </Tooltip>
  )
}
